import { render, staticRenderFns } from "./VerticalRedText.vue?vue&type=template&id=1fae561a&scoped=true&lang=pug&"
import script from "./VerticalRedText.vue?vue&type=script&lang=js&"
export * from "./VerticalRedText.vue?vue&type=script&lang=js&"
import style0 from "./VerticalRedText.vue?vue&type=style&index=0&id=1fae561a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae561a",
  null
  
)

export default component.exports